export const INITIAL_SCHEMA = {
  title: '', // Título da página! ==> (Required)
  breadcrumbs: false,
  background: {
    desktopImage: '', // Background image desktop!
    desktopColor: '#FFFFFF', // Background color desktop!
    mobileImage: '', // Background image mobile!
    mobileColor: '#FFFFFF' // Background color mobile!
  }
};

export const INITIAL_CONFIG = {
  config: {
    dark: false,
    menu: false,
    sidebar: false,
    container: {
      fluid: true,
      gridListMd: false
    }
  },
  paths: {},
  theme: {
    accent: '#e5e5e5',
    error: '#ff5252',
    info: '#2196f3',
    primary: '#e5e5e5',
    secondary: '#e5e5e5',
    success: '#4caf50',
    warning: '#fb8c00'
  },
  header: {
    logo: {
      alt: '',
      class: '',
      src: '',
      height: 42,
      width: '',
      visible: true
    },
    logoRight: {
      alt: '',
      class: '',
      src: '',
      height: 42,
      width: '',
      visible: false
    },
    attributes: {
      absolute: false,
      app: true,
      bottom: false,
      clippedLeft: false,
      clippedRight: false,
      collapse: false,
      color: '#C21818',
      dark: false,
      dense: false,
      elevation: 0,
      extensionHeight: 36,
      flat: false,
      floating: false,
      height: '',
      light: false,
      maxHeight: '',
      maxWidth: '',
      minHeight: '',
      minWidth: '',
      prominent: false,
      short: false,
      src: '',
      tag: 'header',
      tile: true,
      width: ''
    }
  },
  menu: {
    attributes: {
      absolute: false,
      bottom: false,
      collapse: false,
      color: '#C21818',
      dark: false,
      dense: false,
      elevation: 0,
      extended: false,
      extensionHeight: 48,
      flat: false,
      floating: false,
      height: 36,
      light: false,
      maxHeight: 36,
      maxWidth: '100%',
      minHeight: 36,
      minWidth: '100%',
      width: '100%',
      prominent: false,
      short: false,
      src: '',
      tag: 'header',
      tile: true
    }
  },
  breadcrumbs: {
    divider: '',
    accessibility: false
  },
  sidebar: {
    src: '',
    color: '#e5e5e5',
    dark: false,
    light: false,
    width: 256
  },
  footer: {
    visible: false,
    page: '',
    mode: '',
    showPage: false,
    background: {
      image: '',
      color: '#e5e5e5'
    },
    atributes: {
      absolute: false,
      inset: false,
      class: ''
    }
  },
  progressbar: {
    color: '#e5e5e5',
    failedColor: '#e5e5e5',
    thickness: '',
    autoRevert: false,
    location: '',
    inverse: false
  },
  login: {
    componentName: 'i4pro-login',
    params: {
      companyName: '',
      backgroundImage: '',
      backgroundColor: '#e5e5e5',
      logo: {
        src: '',
        srcHeight: '',
        srcWidth: ''
      },
      title: {
        visible: true,
        value: 'Portal titulo',
        style: '',
        class: ''
      },
      subtitle: {
        visible: true,
        value: 'Portal subtitulo',
        style: '',
        class: ''
      }
    }
  },
  dialogs: {}
};

export const DEFAULT_MODES = {
  list: {
    attributes: {
      //--> Configurações para o layout da tela e modos list e card. ==> (Required)
      actionsToolbar: true, // Habilita os botões na toolbar da lista.
      attributesLayout: {
        dense: true,
        reverseOrder: false
      }, //--> Propriedades css do flex-box para posicionar elementos na tela.
      attributesTable: {
        //--> Contém as configurações da table (list)
        keyValue: 'name',
        showSearch: true,
        titleTable: '',
        editIcon: 'edit',
        editIconTooltip: '',
        editMode: '',
        dataTable: {
          dense: true,
          showSelect: false,
          multiSort: false,
          showExpand: false,
          expandAll: false,
          hideActions: false,
          hideDefaultFooter: false,
          externalPagination: true,
          sortBy: [''],
          loadingText: 'Carregando...',
          noDataText: 'Sem dados...',
          noResultsText: 'Sem resultados...',
          footerProps: {
            showFirstLastPage: true,
            firstIcon: 'fas fa-angle-double-left',
            lastIcon: 'fas fa-angle-double-right',
            prevIcon: 'keyboard_arrow_left',
            nextIcon: 'keyboard_arrow_right'
          }
        },
        itemsPerPageOptions: [
          {
            text: '6',
            value: 6
          },
          {
            text: '12',
            value: 12
          },
          {
            text: '32',
            value: 32
          },
          {
            text: 'Todos',
            value: -1
          }
        ]
      },
      attributesDataIterator: {
        //--> Contém as configurações da table (grid)
        keyValue: '',
        editMode: '',
        itemsPerPage: 4,
        itemsPerPageOptions: [
          {
            text: '4',
            value: 4
          },
          {
            text: '16',
            value: 16
          },
          {
            text: '32',
            value: 32
          },
          {
            text: 'Todos',
            value: -1
          }
        ],
        breakpoints: {
          xs: 12,
          sm: 6,
          md: 3,
          lg: 3,
          xl: 2
        },
        dataIteratorComponents: [
          {
            default: true,
            label: 'List',
            icon: 'receipt',
            component: {
              name: 'field-i4pro-card-list',
              attributes: {}
            }
          }
        ]
      }
    },
    executeInLoad: true, //--> Indica se a procedure vai ser executada assim que carregar a tela ==> (Required)
    display: 'list', //--> Define o modo que a lista irá renderizar inicialmente, por exemplo: list ou grid. ==> (Required)
    dialog: '', // --> Seleciona dialog padrão!
    targetList: 'page', //--> Define onde será renderizado o modo de edição da tela no modo lista, por exemplo: page, dialog, below e sidebar. ==> (Required)
    targetCard: 'page', //--> Define onde será renderizado o modo de edição da tela no modo grid, por exemplo: page, dialog, below e sidebar. ==> (Required)
    // child: {
    //   mode: 'search'
    // }, //--> Define qual o modo de tela que será aberto em conjunto com a tela lista. Vem desabilitado por padrão!
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    fields: [], //--> Lista de campos que aparecerá na lista quando for definido que a table é editável
    groups: [],
    headers: [
      {
        text: 'Dessert',
        value: 'name',
        align: 'left',
        sortable: false,
        width: 'auto',
        visible: true
      },
      {
        text: 'Calories',
        value: 'calories',
        align: 'center',
        sortable: true,
        width: 'auto',
        visible: true
      },
      {
        text: 'Carbs',
        value: 'carbs',
        align: 'center',
        sortable: true,
        width: 'auto',
        visible: true
      }
    ], //--> Define quais as colunas serão exibidas na lista e nos cards da tela. ==> (Required)
    items: [],
    actions: {}, //--> Contém as configurações dos botões de ações da tela ==> (Required)
    recordActions: {},
    recordActionsModel: [],
    conditions: [], //--> Contém uma lista de regras das condições ==> (Required)
    lookups: {} //--> Controle interno do sistema, precisa somente existir a propriedade.
  },

  form: {
    attributes: {
      //--> Configurações para o layout da tela. ==> (Required)
      attributesLayout: {
        dense: true,
        reverseOrder: false
      } //--> Propriedades do flex css para posicionar elementos na tela. ==> (Required)
    },
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    // tabs: {}, //--> Contém as configurações das tabs da tela.
    // steps: {}, //--> Contém as configurações dos steps da tela.
    fields: [], //--> Lista de campos forms da tela.
    groups: [], //--> Lista de grupos de coluna para agrupar os fields na tela.
    actions: {}, //--> Contém as configurações dos botões de ações da tela.
    conditions: [] //--> Contém uma lista de regras das condições.
  },

  new: {
    attributes: {
      //--> Configurações para o layout da tela. ==> (Required)
      attributesLayout: {
        dense: true,
        reverseOrder: false
      } //--> Propriedades do flex css para posicionar elementos na tela. ==> (Required)
    },
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    // tabs: {}, //--> Contém as configurações das tabs da tela.
    // steps: {}, //--> Contém as configurações dos steps da tela.
    fields: [], //--> Lista de campos forms da tela. ==> (Required)
    groups: [], //--> Lista de grupos de coluna para agrupar os fields na tela. ==> (Required)
    actions: {}, //--> Contém as configurações dos botões de ações da tela. ==> (Required)
    conditions: [] //--> Contém uma lista de regras das condições. ==> (Required)
  },

  search: {
    attributes: {
      //--> Configurações para o layout da tela. ==> (Required)
      attributesLayout: {
        dense: true,
        reverseOrder: false
      } //--> Propriedades do flex css para posicionar elementos na tela. ==> (Required)
    },
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    fields: [], //--> Lista de campos forms da tela. ==> (Required)
    groups: [], //--> Lista de grupos de coluna para agrupar os fields na tela.
    actions: {}, //--> Contém as configurações dos botões de ações da tela.
    conditions: [] //--> Contém uma lista de regras das condições. ==> (Required)
  },

  sidebar: {
    attributes: {
      //--> Configurações para o layout da tela. ==> (Required)
      attributesLayout: {
        dense: true,
        reverseOrder: false
      }, //--> Propriedades do flex css para posicionar elementos na tela. ==> (Required)
      attributesNavigationDrawer: {
        height: '100%',
        width: '40%'
      }
    },
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    fields: [], //--> Lista de campos forms da tela. ==> (Required)
    groups: [], //--> Lista de grupos de coluna para agrupar os fields na tela. ==> (Required)
    actions: {}, //--> Contém as configurações dos botões de ações da tela. ==> (Required)
    conditions: [] //--> Contém uma lista de regras das condições. ==> (Required)
  }
};

const dec2hex = dec => {
  return dec.toString(16).padStart(2, '0');
};

export const randomString = () => {
  let arr = new Uint8Array(24 / 2);

  window.crypto.getRandomValues(arr);

  return Array.from(arr, dec2hex).join('');
};

export const addMandatoryParameters = schema => {
  const modes = ['list', 'form', 'new', 'search', 'sidebar'];

  if (!('title' in schema)) {
    schema.title = '';
  }

  if (!('breadcrumbs' in schema)) {
    schema.breadcrumbs = false;
  }

  if (!('background' in schema)) {
    schema.background = {
      desktopImage: '',
      desktopColor: '#FFFFFF',
      mobileImage: '',
      mobileColor: '#FFFFFF'
    };
  } else {
    schema.background.desktopColor === '' && (schema.background.desktopColor = '#FFFFFF');
    schema.background.mobileColor === '' && (schema.background.mobileColor = '#FFFFFF');
  }

  if ('list' in schema) {
    if (!schema.list.hasOwnProperty('recordActions')) {
      schema.list.recordActionsModel = [];
      schema.list.recordActions = {};
    }

    if (!schema.list.conditions) {
      schema.list.conditions = [];
    }

    if (!schema.list.inlineConditions) {
      schema.list.inlineConditions = [];
    }

    if ('actions' in schema.list && !'model' in schema.list.actions) {
      schema.list.actions.model = randomString();
    }
  }

  modes.forEach(mode => {
    if (mode in schema) {
      if (mode !== 'list') {
        if ('groups' in schema[mode] && schema[mode].groups.length) {
          schema[mode].groups.forEach(group => {
            if (!('type' in group)) group.type = 'i4proColumnGroup';

            if (!('model' in group)) group.model = randomString();
          });
        }

        if ('tabs' in schema[mode]) {
          if (!('model' in schema[mode].tabs)) schema[mode].tabs.model = randomString();

          if (!('type' in schema[mode].tabs)) schema[mode].tabs.type = 'i4proTabs';

          for (let tab in schema[mode].tabs.content) addModelInActions(schema[mode].tabs.content[tab]);
        }

        if ('steps' in schema[mode]) {
          if (!('model' in schema[mode].steps)) schema[mode].steps.model = randomString();

          if (!('type' in schema[mode].steps)) schema[mode].steps.type = schema[mode].steps.attributes.name;

          for (let step in schema[mode].steps.content) addModelInActions(schema[mode].steps.content[step]);
        }

        if ('master' in schema[mode] && Object.keys(schema[mode].master).length !== 0) {
          if (!('model' in schema[mode].master)) schema[mode].master.model = randomString();
        }
      }

      addModelInActions(schema[mode]);
    }
  });

  return schema;
};

export const clearSchemaBeforeSave = (schema, modes) => {
  if ('list' in schema) {
    delete schema.list.procedure.model;

    schema.list.lookups = {};

    'fields' in schema.list &&
      schema.list.fields.forEach(field => {
        if (field.type === 'i4proSelect' && 'procedure' in field && field.procedure.name.length) {
          field.attributesSelect.items = [];
        }
      });

    'groups' in schema.list &&
      schema.list.groups.forEach(group => {
        group.fields.forEach(field => {
          if (field.type === 'i4proSelect' && 'procedure' in field && field.procedure.name.length) {
            field.attributesSelect.items = [];
          }
        });
      });
  }

  modes
    .filter(mode => mode !== 'list')
    .forEach(mode => {
      delete schema[mode].procedure.model;

      schema[mode].fields.forEach(field => {
        if (field.type === 'i4proSelect' && 'procedure' in field && field.procedure.name.length) {
          field.attributesSelect.items = [];
        }
      });

      schema[mode].groups.forEach(group => {
        group.fields.forEach(field => {
          if (field.type === 'i4proSelect' && 'procedure' in field && field.procedure.name.length) {
            field.attributesSelect.items = [];
          }
        });
      });

      if ('master' in schema[mode] && Object.keys(schema[mode].master).length) {
        'fields' in schema[mode].master &&
          schema[mode].master.fields.forEach(field => {
            if (field.type === 'i4proSelect' && 'procedure' in field && field.procedure.name.length) {
              field.attributesSelect.items = [];
            }
          });
      }

      'tabs' in schema[mode] &&
        Object.values(schema[mode].tabs.content).map(content => {
          content.fields.forEach(field => {
            if (field.type === 'i4proSelect' && 'procedure' in field && field.procedure.name.length) {
              field.attributesSelect.items = [];
            }
          });

          content.groups.forEach(group => {
            group.fields.forEach(field => {
              if (field.type === 'i4proSelect' && 'procedure' in field && field.procedure.name.length) {
                field.attributesSelect.items = [];
              }
            });
          });
        });
    });

  return schema;
};

const addModelInActions = params => {
  if ('actions' in params && Object.keys(params.actions).length !== 0) {
    if (!('model' in params.actions)) params.actions.model = randomString();

    if (!('type' in params)) {
      let type = 'i4proButton';
      if (params.actions.component === 'i4pro-fab-transition') type = 'i4proFabTransition';
      if (params.actions.component === 'i4pro-floating-action-buttons') type = 'i4proFloatingActionButtons';

      params.actions.type = type;
    }
  }
};
